"use client";

import { useEffect, useState, useRef } from "react";
import useApiQuery from "lib/api/useApiQuery";
import { TransactionItem } from "./types";

export const useTransactions = () => {
  const {
    data: txsData,
    isError,
    error,
    isLoading,
  } = useApiQuery("homepage_txs", {
    queryOptions: {
      refetchInterval: 3000,
    },
  });

  const transactions = (txsData as TransactionItem[])?.slice(0, 4) || [];
  const [newItemId, setNewItemId] = useState<string | null>(null);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const prevFirstIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (transactions.length > 0) {
      const currentFirstId = transactions[0].hash;
      if (
        prevFirstIdRef.current !== null &&
        prevFirstIdRef.current !== currentFirstId
      ) {
        setNewItemId(currentFirstId);
        setTimeout(() => setNewItemId(null), 500);
      }
      prevFirstIdRef.current = currentFirstId;
      if (isFirstLoad) setIsFirstLoad(false);
    }
  }, [transactions, isFirstLoad]);

  return { transactions, isLoading, isFirstLoad, newItemId };
};
